import { PasswordResetForm } from '@/components/features/auth/PasswordResetForm';
import AuthView from '@/layout/AuthView';

export default function PasswordResetPage() {
  return (
    <AuthView>
      <div
        className={
          'border-border-primary bg-background relative z-10 flex min-h-[calc(100dvh-var(--spacing)*6)] w-full flex-col overflow-auto rounded-2xl rounded-b-none border px-4 pt-6 pb-11 md:min-h-fit md:w-[clamp(22rem,50dvw,26rem)] md:rounded-b-2xl md:border-4 md:px-4 md:pt-4 md:pb-4 md:shadow-lg'
        }
      >
        <PasswordResetForm />
      </div>
    </AuthView>
  );
}
